'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var loadScriptAsync = _interopDefault(require('async-scripts-loader'));
var firebase = _interopDefault(require('firebase/app'));
var EventEmitter = _interopDefault(require('eventemitter3'));
var uuidv4 = _interopDefault(require('uuid/v4'));
var uuidv5 = _interopDefault(require('uuid/v5'));
var xorBy = _interopDefault(require('lodash/xorBy'));
var uniq = _interopDefault(require('lodash/uniq'));
var maxBy = _interopDefault(require('lodash/maxBy'));
var dateFns = require('date-fns');
var store = _interopDefault(require('store2'));

var User = /** @class */ (function () {
    function User(client, userId, displayName, internalMessagingUser, type, avatarUrl, expertRating, vanityId, guest) {
        if (guest === void 0) { guest = false; }
        this._client = client;
        this._userId = userId;
        this._vanityId = vanityId;
        this._displayName = displayName;
        this._internalMessagingUser = internalMessagingUser;
        this._type = type;
        this._avatarUrl = avatarUrl;
        this._expertRating = expertRating;
        this._guest = guest;
    }
    Object.defineProperty(User.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "displayName", {
        get: function () {
            return this._displayName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "avatarUrl", {
        get: function () {
            return this._avatarUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isMyself", {
        get: function () {
            return this._client.myself && this._userId === this._client.myself.userId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isGuest", {
        get: function () {
            return this._guest;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "isInternalMessagingUser", {
        get: function () {
            return this._internalMessagingUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "expertRating", {
        get: function () {
            return this._expertRating;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "vanityId", {
        get: function () {
            return this._vanityId;
        },
        enumerable: true,
        configurable: true
    });
    return User;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var Timestamp = /** @class */ (function () {
    function Timestamp(seconds, nanoseconds, serverTimestamp) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
        this.serverTimestamp = serverTimestamp || false;
        this.toDate = this.toDate.bind(this);
        this.toMillis = this.toMillis.bind(this);
    }
    Timestamp.fromDate = function (date) {
        return Timestamp.fromMillis(date.getTime());
    };
    Timestamp.now = function () {
        return Timestamp.fromMillis(Date.now());
    };
    Timestamp.serverTimestamp = function () {
        var now = this.now();
        return new Timestamp(now.seconds, now.nanoseconds, true);
    };
    Timestamp.fromMillis = function (millis) {
        return new Timestamp(Math.trunc(millis / 1000), (millis % 1000) * 1000000);
    };
    Timestamp.of = function (seconds, nanoseconds) {
        return new Timestamp(seconds, nanoseconds);
    };
    Timestamp.prototype.toDate = function () {
        return new Date(this.seconds * 1000 + this.nanoseconds / 1000000);
    };
    Timestamp.prototype.toMillis = function () {
        return this.seconds * 1000 + this.nanoseconds / 1000000;
    };
    Timestamp.prototype.isBefore = function (other) {
        return this.compareTo(other) < 0;
    };
    Timestamp.prototype.isAfter = function (other) {
        return this.compareTo(other) > 0;
    };
    Timestamp.prototype.compareTo = function (other) {
        if (this.seconds < other.seconds) {
            return -1;
        }
        if (this.seconds > other.seconds) {
            return 1;
        }
        if (this.nanoseconds < other.nanoseconds) {
            return -1;
        }
        if (this.nanoseconds > other.nanoseconds) {
            return 1;
        }
        return 0;
    };
    Timestamp.EPOCH = new Timestamp(0, 0);
    return Timestamp;
}());

var BaseModel = /** @class */ (function () {
    function BaseModel() {
        this._eventEmitter = new EventEmitter();
    }
    BaseModel.prototype.on = function (event, fn, context) {
        this._eventEmitter.on(event, fn, context);
        return this;
    };
    BaseModel.prototype.once = function (event, fn, context) {
        this._eventEmitter.once(event, fn, context);
        return this;
    };
    BaseModel.prototype.off = function (event, fn, context, once) {
        var _this = this;
        var events = (event && [event]) || this._eventEmitter.eventNames();
        events.forEach(function (oneEvent) {
            if (fn || (!context && !once)) {
                // When listener is given, or context and once are not given,
                _this._eventEmitter.off(oneEvent, fn, context, once);
            }
            else {
                // When listener is not given, but context and/or once is given, we need to iterate through all listeners
                _this._eventEmitter.listeners(oneEvent).forEach(function (listener) {
                    _this._eventEmitter.off(oneEvent, listener, context, once);
                });
            }
        });
        return this;
    };
    BaseModel.prototype.close = function () {
        this._eventEmitter.removeAllListeners();
    };
    return BaseModel;
}());

var Conversation = /** @class */ (function (_super) {
    __extends(Conversation, _super);
    function Conversation(client, conversationId) {
        var _this = _super.call(this) || this;
        _this._client = client;
        _this._conversationId = conversationId;
        _this._typingTimeouts = new Map();
        _this._createdAt = Timestamp.now();
        _this._updatedAt = Timestamp.now();
        _this._participants = [];
        _this._participantIds = new Set();
        _this._unreadCount = 0;
        _this._readOnly = true;
        _this._metadata = {};
        _this._initialized = false;
        _this.getMessage = _this.getMessage.bind(_this);
        _this.sendMessage = _this.sendMessage.bind(_this);
        _this.startTyping = _this.startTyping.bind(_this);
        _this.stopTyping = _this.stopTyping.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.markConversationRead = _this.markConversationRead.bind(_this);
        _this.markConversationDelivered = _this.markConversationDelivered.bind(_this);
        _this.createDraftMessage = _this.createDraftMessage.bind(_this);
        return _this;
    }
    Object.defineProperty(Conversation.prototype, "_me", {
        get: function () {
            return this._client.myself;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "conversationId", {
        get: function () {
            return this._conversationId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "createdAt", {
        get: function () {
            return this._createdAt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "updatedAt", {
        get: function () {
            return this._updatedAt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "lastMessage", {
        get: function () {
            return this._lastMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "participants", {
        get: function () {
            return this._participants.slice(0);
        },
        set: function (newParticipants) {
            this._participantIds = new Set(newParticipants.map(function (user) { return user.userId; }));
            this._participants = newParticipants;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "isParticipant", {
        get: function () {
            return this._participantIds.has(this._me.userId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "unreadCount", {
        get: function () {
            return this._unreadCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "readOnly", {
        get: function () {
            return this._readOnly || !this.isParticipant;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Conversation.prototype, "metadata", {
        get: function () {
            return Object.assign({}, this._metadata);
        },
        enumerable: true,
        configurable: true
    });
    Conversation.prototype.handleTyping = function (userId, timeoutTimestamp) {
        var _this = this;
        if (this._me && userId === this._me.userId) {
            // Self, no need to handle typing
            return;
        }
        var wasTyping = this._typingTimeouts.has(userId);
        // const timeout = (
        //   fromFirebaseTimestamp(typingTimestamp.get('timestamp')) || Timestamp.EPOCH
        // ).toMillis()
        var now = Date.now();
        if (wasTyping) {
            // need to clear the timeout
            clearTimeout(this._typingTimeouts.get(userId));
            this._typingTimeouts.delete(userId);
        }
        if (now < timeoutTimestamp) {
            if (!wasTyping) {
                // User started typing
                this.fireTyping(userId, true);
            }
            this._typingTimeouts.set(userId, setTimeout(function () {
                _this._typingTimeouts.delete(userId);
                // User typing expired
                _this.fireTyping(userId, false);
            }, timeoutTimestamp - now));
        }
        else {
            if (wasTyping) {
                // User stopped typing
                this.fireTyping(userId, false);
            }
        }
    };
    Conversation.prototype.on = function (event, callback, context) {
        var _this = this;
        if (event === 'typingStarted') {
            // Special case for typing started events. Call the callback for every user that is typing now.
            this._client.getUsers(Array.from(this._typingTimeouts.keys())).then(function (users) {
                return users.forEach(function (user) {
                    callback.call(context, {
                        event: event,
                        conversation: _this,
                        user: user,
                    });
                });
            });
        }
        return _super.prototype.on.call(this, event, callback, context);
    };
    Conversation.prototype.fireTyping = function (userId, typing) {
        var _this = this;
        this._client.getUsers([userId]).then(function (_a) {
            var user = _a[0];
            var eventName = typing ? 'typingStarted' : 'typingStopped';
            _this._eventEmitter.emit(eventName, {
                event: eventName,
                conversation: _this,
                user: user,
            });
        });
    };
    return Conversation;
}(BaseModel));

var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message(conversation, messageId, sentBy) {
        var _this = _super.call(this) || this;
        _this._conversation = conversation;
        _this._messageId = messageId;
        _this._sentBy = sentBy;
        _this._realSender = sentBy;
        _this._parts = [];
        _this._metadata = {};
        _this._receipts = {};
        _this._draft = false;
        _this._sentAt = Timestamp.serverTimestamp();
        _this._pending = false;
        _this._initialized = false;
        _this.initDraft = _this.initDraft.bind(_this);
        _this.finalizeDraft = _this.finalizeDraft.bind(_this);
        _this.addDraftPart = _this.addDraftPart.bind(_this);
        return _this;
    }
    Object.defineProperty(Message.prototype, "conversation", {
        get: function () {
            return this._conversation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "messageId", {
        get: function () {
            return this._messageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "sentAt", {
        get: function () {
            return this._sentAt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "sentBy", {
        get: function () {
            return this._sentBy;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "parts", {
        get: function () {
            return this._parts;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "channels", {
        get: function () {
            return this._channels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "skipChannels", {
        get: function () {
            return this._skipChannels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "sentVia", {
        get: function () {
            return this._sentVia;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "metadata", {
        get: function () {
            return this._metadata;
        },
        set: function (data) {
            if (!this._draft) {
                throw new Error('Changing metadata not allowed in non-draft message');
            }
            this._metadata = Object.assign({}, data);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "pending", {
        get: function () {
            return this._pending;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "draft", {
        get: function () {
            return this._draft;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "receipts", {
        get: function () {
            var _this = this;
            var receipts = {};
            this._conversation.participants.forEach(function (participant) {
                if (_this._pending) {
                    receipts[participant.userId] = exports.MessageReceiptType.PENDING;
                }
                else {
                    receipts[participant.userId] = _this._receipts[participant.userId] || exports.MessageReceiptType.SENT;
                }
            });
            return receipts;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "realSender", {
        get: function () {
            return this._realSender;
        },
        enumerable: true,
        configurable: true
    });
    Message.prototype.initDraft = function () {
        if (this._initialized) {
            throw new Error('Already initialized!');
        }
        this._initialized = true;
        this._draft = true;
        this._receipts = {};
        this._eventEmitter.emit('initialized', {
            event: 'initialized',
            message: this
        });
        return this;
    };
    Message.prototype.finalizeDraft = function () {
        this._draft = false;
        this._pending = true;
        this._receipts[this._sentBy.userId] = exports.MessageReceiptType.READ;
        Object.freeze(this._parts);
        Object.freeze(this._metadata);
        Object.freeze(this._channels);
        Object.freeze(this._skipChannels);
    };
    return Message;
}(BaseModel));
(function (MessageChannel) {
    MessageChannel["SMS"] = "SMS";
    MessageChannel["EMAIL"] = "EMAIL";
    MessageChannel["FACEBOOK"] = "FACEBOOK";
})(exports.MessageChannel || (exports.MessageChannel = {}));
(function (MessageReceiptType) {
    MessageReceiptType[MessageReceiptType["PENDING"] = 0] = "PENDING";
    MessageReceiptType[MessageReceiptType["SENT"] = 1] = "SENT";
    MessageReceiptType[MessageReceiptType["DELIVERED"] = 2] = "DELIVERED";
    MessageReceiptType[MessageReceiptType["READ"] = 3] = "READ";
})(exports.MessageReceiptType || (exports.MessageReceiptType = {}));

var MessageQuery = /** @class */ (function (_super) {
    __extends(MessageQuery, _super);
    function MessageQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageQuery;
}(BaseModel));

// Static UUID v5 namespace.
//   See: https://www.npmjs.com/package/uuid
var UUID_NAMESPACE = 'b0a44543-f3c9-420e-8554-aeb88bb2ae3e';
var Id = /** @class */ (function () {
    function Id(type, seed) {
        this._id = uuidv5(seed || uuidv4(), UUID_NAMESPACE);
        this._type = type;
    }
    Object.defineProperty(Id.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Id.prototype.toString = function () {
        return Id._prefix + ":" + this._type + ":" + this._id;
    };
    Id.prototype.encode = function () {
        return this.toString();
    };
    Id.decode = function (encodedId) {
        var _a = encodedId.split(':'), prefix = _a[0], type = _a[1], id = _a[2];
        if (prefix !== Id._prefix || type === undefined || id === undefined) {
            throw new Error("Can not decode invalid ID: \"" + encodedId + "\"");
        }
        return new this(type, id);
    };
    Id.isOfType = function (type, encodedId) {
        try {
            return Id.decode(encodedId).type === type;
        }
        catch (_a) {
            return false;
        }
    };
    Id._prefix = 'id';
    return Id;
}());

function fromFirebaseTimestamp(timestamp) {
    return timestamp && Timestamp.of(timestamp.seconds, timestamp.nanoseconds);
}
function toFirebaseTimestamp(timestamp) {
    if (timestamp) {
        return timestamp.serverTimestamp
            ? firebase.firestore.FieldValue.serverTimestamp()
            : new firebase.firestore.Timestamp(timestamp.seconds, timestamp.nanoseconds);
    }
}

var FirebaseMessage = /** @class */ (function (_super) {
    __extends(FirebaseMessage, _super);
    function FirebaseMessage(client, conversation, messageId) {
        var _this = _super.call(this, conversation, messageId, client.myself) || this;
        _this._client = client;
        _this.init = _this.init.bind(_this);
        _this.initDraft = _this.initDraft.bind(_this);
        _this.finalizeDraft = _this.finalizeDraft.bind(_this);
        _this.updateMessage = _this.updateMessage.bind(_this);
        _this.handleReadUntilChange = _this.handleReadUntilChange.bind(_this);
        _this.handleDeliveredUntilChange = _this.handleDeliveredUntilChange.bind(_this);
        _this.addDraftPart = _this.addDraftPart.bind(_this);
        return _this;
    }
    Object.defineProperty(FirebaseMessage.prototype, "read", {
        get: function () {
            return this._receipts[this._client.myself.userId] === exports.MessageReceiptType.READ;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseMessage.prototype.createPartFromFirestoreData = function (part) {
        return new FirebaseMessagePart(part.type, JSON.parse(part.body), this);
    };
    FirebaseMessage.prototype.addDraftPart = function (type, body) {
        if (!this.draft) {
            throw new Error('Message is not a draft, unable to create draft parts');
        }
        var part = new FirebaseMessagePart(type, body, this);
        this.parts.push(part);
        return part;
    };
    FirebaseMessage.prototype.initMessage = function (message, deliveryTimestamps, readTimestamps, sentBy, realSender) {
        var _this = this;
        var messageDoc = message.data({ serverTimestamps: 'estimate' });
        this._sentAt = fromFirebaseTimestamp(messageDoc.sentAt) || Timestamp.now();
        this._sentBy = sentBy;
        this._realSender = realSender;
        this._metadata = messageDoc.metadata;
        this._channels = messageDoc.channels;
        this._skipChannels = messageDoc.skipChannels;
        this._sentVia = messageDoc.sentVia;
        this._parts = messageDoc.parts.map(function (part) {
            return _this.createPartFromFirestoreData(part);
        });
        this._pending = message.metadata.hasPendingWrites;
        this._receipts = {};
        this._receipts[messageDoc.sentBy] = exports.MessageReceiptType.READ;
        deliveryTimestamps.forEach(function (timestamp) { return _this.updateDeliveryReceipt(timestamp); });
        readTimestamps.forEach(function (timestamp) { return _this.updateReadReceipt(timestamp); });
        Object.freeze(this._parts);
        Object.freeze(this._metadata);
        Object.freeze(this._channels);
        Object.freeze(this._skipChannels);
        this._initialized = true;
        this._eventEmitter.emit('initialized', {
            event: 'initialized',
            message: this
        });
        return this;
    };
    FirebaseMessage.prototype.init = function (message, deliveryTimestamps, readTimestamps) {
        var _this = this;
        if (message.id !== this._messageId) {
            throw new Error("Expect message " + this._messageId + ", but found " + message.id);
        }
        if (this._initialized) {
            return Promise.resolve(this);
        }
        var messageDoc = message.data({ serverTimestamps: 'estimate' });
        if (messageDoc.realSenderId) {
            return this._client.getUsers([messageDoc.sentBy, messageDoc.realSenderId]).then(function (users) {
                var userMap = new Map();
                users.forEach(function (user) { return userMap.set(user.userId, user); });
                var realSender = userMap.get(messageDoc.realSenderId);
                var sentBy = userMap.get(messageDoc.sentBy);
                return _this.initMessage(message, deliveryTimestamps, readTimestamps, sentBy, realSender);
            });
        }
        else {
            return this._client
                .getUsers([messageDoc.sentBy])
                .then(function (_a) {
                var sentBy = _a[0];
                return _this.initMessage(message, deliveryTimestamps, readTimestamps, sentBy, sentBy);
            });
        }
    };
    FirebaseMessage.prototype.updateMessage = function (message) {
        this._metadata = message.get('metadata');
        Object.freeze(this._metadata);
        if (this._pending && !message.metadata.hasPendingWrites) {
            this._pending = false;
            this._sentAt = fromFirebaseTimestamp(message.get('sentAt')) || Timestamp.now();
            if (this._initialized) {
                this._eventEmitter.emit('sent', {
                    event: 'sent',
                    message: this
                });
            }
        }
        else {
            this._eventEmitter.emit('changed', {
                event: 'changed',
                message: this
            });
        }
    };
    FirebaseMessage.prototype.updateDeliveryReceipt = function (doc) {
        var timestamp = fromFirebaseTimestamp(doc.get('timestamp')) || Timestamp.EPOCH;
        var userId = doc.get('userId');
        if (!timestamp.isBefore(this._sentAt) &&
            this._receipts[userId] !== exports.MessageReceiptType.READ &&
            this._receipts[userId] !== exports.MessageReceiptType.DELIVERED) {
            this._receipts[userId] = exports.MessageReceiptType.DELIVERED;
            if (this._initialized && this._client.myself.userId !== userId) {
                this._eventEmitter.emit('delivered', {
                    event: 'delivered',
                    message: this,
                    userId: userId
                });
            }
        }
    };
    FirebaseMessage.prototype.handleDeliveredUntilChange = function (change) {
        switch (change.type) {
            case 'removed': {
                delete this._receipts[change.doc.id];
                break;
            }
            case 'added':
            case 'modified': {
                this.updateDeliveryReceipt(change.doc);
                break;
            }
        }
    };
    FirebaseMessage.prototype.updateReadReceipt = function (doc) {
        var timestamp = fromFirebaseTimestamp(doc.get('timestamp')) || Timestamp.EPOCH;
        var userId = doc.get('userId');
        if (!timestamp.isBefore(this._sentAt) && this._receipts[userId] !== exports.MessageReceiptType.READ) {
            this._receipts[userId] = exports.MessageReceiptType.READ;
            if (this._initialized && this._client.myself.userId !== userId) {
                this._eventEmitter.emit('read', {
                    event: 'read',
                    message: this,
                    userId: userId
                });
            }
        }
    };
    FirebaseMessage.prototype.handleReadUntilChange = function (change) {
        switch (change.type) {
            case 'removed': {
                delete this._receipts[change.doc.id];
                break;
            }
            case 'added':
            case 'modified': {
                this.updateReadReceipt(change.doc);
                break;
            }
        }
    };
    return FirebaseMessage;
}(Message));
var FirebaseMessageId = /** @class */ (function (_super) {
    __extends(FirebaseMessageId, _super);
    function FirebaseMessageId(seed) {
        return _super.call(this, 'firebase-message', seed) || this;
    }
    FirebaseMessageId.isFirebaseMessageId = function (encodedId) {
        return Id.isOfType('firebase-message', encodedId);
    };
    return FirebaseMessageId;
}(Id));
var FirebaseMessagePart = /** @class */ (function () {
    function FirebaseMessagePart(type, body, message) {
        this.type = type;
        this.body = body;
        this.message = message;
    }
    FirebaseMessagePart.prototype.toFirestoreData = function () {
        return {
            type: this.type,
            body: JSON.stringify(this.body)
        };
    };
    return FirebaseMessagePart;
}());

var FirebaseMessageQuery = /** @class */ (function (_super) {
    __extends(FirebaseMessageQuery, _super);
    function FirebaseMessageQuery(store, conversation, client, limit) {
        var _this = _super.call(this) || this;
        _this._store = store;
        _this._conversation = conversation;
        _this._client = client;
        _this._existingMessages = [];
        _this._newMessages = [];
        _this._initialized = false;
        _this._hasMore = false;
        _this._pendingFetchMorePromises = [];
        _this.close = _this.close.bind(_this);
        _this.more = _this.more.bind(_this);
        _this._store
            .collection('conversations')
            .doc(_this._conversation.conversationId)
            .collection('messages')
            .orderBy('sentAt', 'desc')
            .limit(limit)
            .get()
            .then(function (snapshot) {
            Promise.all(snapshot.docs.map(function (doc) { return _this._conversation.getMessageInternal(doc); })).then(function (existingMessages) {
                _this._hasMore = snapshot.size === limit;
                _this._existingMessages = existingMessages;
                _this.recomputeList();
                // Subscribe to any new messages after the latest one
                var query = _this._store
                    .collection('conversations')
                    .doc(_this._conversation.conversationId)
                    .collection('messages')
                    .orderBy('sentAt', 'desc');
                if (!snapshot.empty && snapshot.docs.length > 0) {
                    // there are already some messages, need to subscribe to any new ones (time-wise, after the latest message)
                    // the sentAt should not be null, but we are seeing some exceptions indicating sentAt is null
                    // So when sentAt is null for some reason, fallback to the current time
                    var lastSentAt = snapshot.docs[0].get('sentAt') || toFirebaseTimestamp(Timestamp.now());
                    query = query.where('sentAt', '>', lastSentAt);
                    // Also check delivery timestamps
                    var deliveredUntil = _this._conversation.myDeliveryTimestamp;
                    if (!deliveredUntil || deliveredUntil.isBefore(fromFirebaseTimestamp(lastSentAt))) {
                        // Need to update delivery timestamp up to the first message
                        _this._conversation.markConversationDelivered(snapshot.docs[0].id);
                    }
                }
                _this._unsubscribeNewMessages = query.onSnapshot(function (newMessagesSnapshot) {
                    Promise.all(newMessagesSnapshot.docs.map(function (doc) { return _this._conversation.getMessageInternal(doc); })).then(function (newMessages) {
                        /*
                        Do not add any "new" messages that are already stored in this._existingMessages
                        When a user messages a new expert (creating a lead, conversation & first message on the fly) the first message can appear in both the
                        existing message query and new message subscription causing duplicate messages across  both this._existingMessage and this._newMessages
                        **/
                        _this._newMessages = newMessages.filter(function (message) {
                            return !_this._existingMessages.some(function (existingMessage) { return existingMessage.messageId === message.messageId; });
                        });
                        _this.recomputeList();
                    });
                }, function (error) {
                    return console.error("Conversation " + _this._conversation.conversationId + " Query New Message Subscription Empty Error (me=" + (_this._client.myself && _this._client.myself.userId) + "): ", error);
                });
                _this._initialized = true;
                _this._eventEmitter.emit('initialized', {
                    event: 'initialized',
                    query: _this
                });
            });
        });
        return _this;
    }
    Object.defineProperty(FirebaseMessageQuery.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseMessageQuery.prototype, "hasMore", {
        get: function () {
            return this._hasMore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseMessageQuery.prototype, "messages", {
        get: function () {
            return this._newMessages.concat(this._existingMessages);
        },
        enumerable: true,
        configurable: true
    });
    FirebaseMessageQuery.prototype.recomputeList = function () {
        if (this._initialized) {
            this._eventEmitter.emit('updated', {
                event: 'updated',
                query: this
            });
        }
    };
    FirebaseMessageQuery.prototype.more = function (limit) {
        var _this = this;
        var promise;
        if (this._pendingFetchMorePromises.length > 0) {
            promise = this._pendingFetchMorePromises[this._pendingFetchMorePromises.length - 1].then(function () {
                return _this.fetchMore(limit);
            });
        }
        else {
            promise = this.fetchMore(limit);
        }
        this._pendingFetchMorePromises.push(promise);
        return promise.then(function (v) {
            _this._pendingFetchMorePromises.shift();
            return v;
        }, function (e) {
            _this._pendingFetchMorePromises.shift();
            throw e;
        });
    };
    FirebaseMessageQuery.prototype.fetchMore = function (limit) {
        var _this = this;
        if (this._hasMore && this._existingMessages.length !== 0) {
            // query for more, which is before the first message in time
            return this._store
                .collection('conversations')
                .doc(this._conversation.conversationId)
                .collection('messages')
                .orderBy('sentAt', 'desc')
                .where('sentAt', '<', toFirebaseTimestamp(this._existingMessages[this._existingMessages.length - 1].sentAt))
                .limit(limit)
                .get()
                .then(function (snapshot) {
                _this._hasMore = snapshot.size === limit;
                if (!snapshot.empty) {
                    return Promise.all(snapshot.docs.map(function (doc) { return _this._conversation.getMessageInternal(doc); })).then(function (moreMessages) {
                        _this._eventEmitter.emit('fetchedMore', {
                            event: 'fetchedMore',
                            query: _this,
                            messages: moreMessages
                        });
                        _this._existingMessages = _this._existingMessages.concat(moreMessages);
                        _this.recomputeList();
                        return _this;
                    });
                }
                return _this;
            });
        }
        return Promise.resolve(this);
    };
    FirebaseMessageQuery.prototype.messagesAfter = function (message, limit) {
        var _this = this;
        // query for messages after the input message and add them to the existing messages
        return this._store
            .collection('conversations')
            .doc(this._conversation.conversationId)
            .collection('messages')
            .orderBy('sentAt', 'asc')
            .where('sentAt', '>', toFirebaseTimestamp(message.sentAt))
            .limit(limit)
            .get()
            .then(function (snapshot) {
            _this._hasMore = snapshot.size === limit;
            if (!snapshot.empty) {
                return Promise.all(snapshot.docs.map(function (doc) { return _this._conversation.getMessageInternal(doc); })).then(function (fetchedMessages) {
                    _this._existingMessages = __spreadArrays([message], fetchedMessages);
                    _this.recomputeList();
                    return _this;
                });
            }
            return _this;
        });
    };
    FirebaseMessageQuery.prototype.close = function () {
        _super.prototype.close.call(this);
        if (this._unsubscribeNewMessages) {
            this._unsubscribeNewMessages();
            this._unsubscribeNewMessages = undefined;
        }
    };
    return FirebaseMessageQuery;
}(MessageQuery));

var FirebaseConversation = /** @class */ (function (_super) {
    __extends(FirebaseConversation, _super);
    function FirebaseConversation(store, client, conversationId) {
        var _this = _super.call(this, client, conversationId) || this;
        _this._store = store;
        _this._messages = new Map();
        // this._typingTimeouts = new Map()
        _this._readTimestamps = [];
        _this._deliveryTimestamps = [];
        _this._messageIdsToBeMarkedAsRead = [];
        _this.init = _this.init.bind(_this);
        _this.updateConversation = _this.updateConversation.bind(_this);
        _this.handleDeliveredUntilChange = _this.handleDeliveredUntilChange.bind(_this);
        _this.handleReadUntilChange = _this.handleReadUntilChange.bind(_this);
        _this.handleTypingUntilChange = _this.handleTypingUntilChange.bind(_this);
        _this.getMessage = _this.getMessage.bind(_this);
        _this.sendMessage = _this.sendMessage.bind(_this);
        _this.startTyping = _this.startTyping.bind(_this);
        _this.stopTyping = _this.stopTyping.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.markConversationRead = _this.markConversationRead.bind(_this);
        _this.markConversationDelivered = _this.markConversationDelivered.bind(_this);
        _this.createDraftMessage = _this.createDraftMessage.bind(_this);
        _this.handleNewMessage = _this.handleNewMessage.bind(_this);
        return _this;
    }
    Object.defineProperty(FirebaseConversation.prototype, "_me", {
        get: function () {
            if (this._client.myself.isGuest) {
                throw new Error('Guest users can not access Firebase');
            }
            return this._client.myself;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseConversation.prototype.handleNewMessage = function (snapshot) {
        var _this = this;
        snapshot.docChanges().forEach(function (change) {
            if (change.type === 'added') {
                _this.getMessageInternal(change.doc).then(function (message) {
                    if (!change.doc.metadata.hasPendingWrites) {
                        // only care about added and persisted events
                        // pending write events are messages sent by this user
                        _this._eventEmitter.emit('newMessage', {
                            event: 'newMessage',
                            conversation: _this,
                            message: message
                        });
                    }
                    // Update the last message in the conversation
                    var modified = false;
                    if (!_this._lastMessage || _this._lastMessage.sentAt.isBefore(message.sentAt)) {
                        _this._lastMessage = message;
                        modified = true;
                    }
                    if (_this.isParticipant && message.sentBy.userId !== _this._me.userId) {
                        var readTimestamp = _this.getMyReadTimestamp();
                        if (!readTimestamp || readTimestamp.isBefore(message.sentAt)) {
                            _this._unreadCount = _this._unreadCount + 1;
                            modified = true;
                        }
                    }
                    if (modified) {
                        _this._eventEmitter.emit('changed', {
                            event: 'changed',
                            conversation: _this
                        });
                    }
                });
            }
            else if (change.type === 'modified') {
                var message = _this._messages.get(change.doc.id);
                if (message) {
                    message.updateMessage(change.doc);
                }
            }
        });
        var latestMessage = snapshot.docs.find(function (doc) { return !doc.metadata.hasPendingWrites; });
        if (latestMessage) {
            // Update the deliveredUntil to the latest message
            this._store
                .collection('conversations')
                .doc(this._conversationId)
                .collection('deliveredUntil')
                .doc(this._me.userId)
                .update('timestamp', latestMessage.get('sentAt'))
                .catch(function (err) {
                if (err.code === 'permission-denied') {
                    // If the timestamp regresses, it would be rejected as permission denied
                    return;
                }
                throw err;
            });
        }
    };
    FirebaseConversation.prototype.init = function (conversation, typingTimestamps, deliveryTimestamps, readTimestamps) {
        var _this = this;
        if (!conversation.exists) {
            // not exist, possibly the network error, so don't do anything until network reestablishes and reexecute this.
            return;
        }
        if (conversation.id !== this._conversationId) {
            throw new Error("Expect conversation " + this._conversationId + ", but found " + conversation.id);
        }
        if (this._initialized) {
            return;
        }
        this._createdAt =
            fromFirebaseTimestamp(conversation.get('createdAt', { serverTimestamps: 'estimate' })) ||
                Timestamp.now();
        this._deliveryTimestamps = deliveryTimestamps;
        this._readTimestamps = readTimestamps;
        // typing indicators
        typingTimestamps.forEach(function (timestamp) { return _this.handleTypingInternal(timestamp); });
        this.updateConversation(conversation);
    };
    FirebaseConversation.prototype.getMyReadTimestamp = function () {
        var _this = this;
        var readTimestamp = this._readTimestamps.find(function (readTimestamp) { return readTimestamp.id === _this._me.userId; });
        return readTimestamp && fromFirebaseTimestamp(readTimestamp.get('timestamp'));
    };
    FirebaseConversation.prototype.updateConversation = function (conversation) {
        var _this = this;
        var data = conversation.data({ serverTimestamps: 'estimate' });
        this._client.getUsers(Object.keys(data.participants)).then(function (participants) {
            _this._readOnly = data.readOnly;
            _this._updatedAt = fromFirebaseTimestamp(data.updatedAt) || Timestamp.now();
            _this._metadata = data.metadata;
            _this._participants = participants;
            _this._participantIds = new Set(participants.map(function (v) { return v.userId; }));
            var lastMessageId;
            if (!_this._initialized) {
                // Once initialized, unread count and last message
                _this._unreadCount =
                    (data.participants[_this._me.userId] && data.participants[_this._me.userId].unreadCount) ||
                        0;
                lastMessageId = data.lastMessage && data.lastMessage.messageId;
            }
            else if (!_this.isParticipant) {
                // When the user is not a participant any more, reset the unread count to 0.
                _this._unreadCount = 0;
            }
            if (lastMessageId) {
                var lastMessage_1 = _this.getMessage(lastMessageId);
                if (lastMessage_1.initialized) {
                    _this._lastMessage = lastMessage_1;
                }
                else {
                    lastMessage_1.once('initialized', function () {
                        if (_this._lastMessage) {
                            // When the initialization finished, but the last message is already updated
                            // most likely it is updated because there is a new last message
                            // so skip the processing
                            return;
                        }
                        _this._lastMessage = lastMessage_1;
                        if (_this._initialized) {
                            _this._eventEmitter.emit('changed', {
                                event: 'changed',
                                conversation: _this
                            });
                        }
                    });
                }
            }
            if (!_this._initialized) {
                // When not initialized, need to subscribe to new messages
                if (lastMessageId) {
                    // When last message exists, subscribe to anything later than the last message
                    _this._unsubscribeNewMessages = _this._store
                        .collection('conversations')
                        .doc(_this._conversationId)
                        .collection('messages')
                        .where('sentAt', '>', data.lastMessage.sentAt)
                        .orderBy('sentAt', 'desc')
                        .onSnapshot({ includeMetadataChanges: true }, _this.handleNewMessage, function (error) {
                        return console.error("Conversation " + _this._conversationId + " New Message Non-Empty Subscription Error (me=" + (_this._me && _this._me.userId) + "): ", error);
                    });
                }
                else {
                    // Otherwise, subscribe to all messages (conversation should be empty)
                    _this._unsubscribeNewMessages = _this._store
                        .collection('conversations')
                        .doc(_this._conversationId)
                        .collection('messages')
                        .orderBy('sentAt', 'desc')
                        .onSnapshot({ includeMetadataChanges: true }, _this.handleNewMessage, function (error) {
                        return console.error("Conversation " + _this._conversationId + " New Message Subscription Empty Error (me=" + (_this._me && _this._me.userId) + "): ", error);
                    });
                }
            }
            if (_this._initialized) {
                _this._eventEmitter.emit('changed', {
                    event: 'changed',
                    conversation: _this
                });
            }
            else {
                _this._initialized = true;
                _this._eventEmitter.emit('initialized', {
                    event: 'initialized',
                    conversation: _this
                });
            }
        });
    };
    FirebaseConversation.prototype.doMarkConversationRead = function (upToMessageIds) {
        var _this = this;
        var readTimestamp = this._readTimestamps.find(function (readTimestamp) { return readTimestamp.id === _this._me.userId; });
        if (readTimestamp) {
            var latestSentAt_1 = upToMessageIds
                .map(function (messageId) { return _this.getMessage(messageId); })
                .filter(function (message) { return !message.pending && message.initialized; })
                .map(function (message) { return message.sentAt; })
                // Find the max
                .reduce(function (prev, current) { return (prev.isBefore(current) ? current : prev); }, Timestamp.EPOCH);
            var readUntil = fromFirebaseTimestamp(readTimestamp.get('timestamp'));
            if (!readUntil || readUntil.isBefore(latestSentAt_1)) {
                // Need to update the readUntil
                readTimestamp.ref.update('timestamp', toFirebaseTimestamp(latestSentAt_1)).catch(function (err) {
                    if (err.code === 'permission-denied') {
                        // If the timestamp regresses, it would be rejected as permission denied
                        return;
                    }
                    throw err;
                });
                // Recount the unreadCount
                this._unreadCount = 0;
                this._messages.forEach(function (message) {
                    if (message.initialized &&
                        message.sentBy.userId !== _this._me.userId &&
                        message.sentAt.isAfter(latestSentAt_1)) {
                        _this._unreadCount = _this._unreadCount + 1;
                    }
                });
                // Fire changed event once readUntil is updated and unread count is re-calculated
                if (this._initialized) {
                    this._eventEmitter.emit('changed', {
                        event: 'changed',
                        conversation: this
                    });
                }
            }
        }
    };
    FirebaseConversation.prototype.markConversationRead = function (upToMessageId) {
        var _this = this;
        if (!this.isParticipant) {
            return;
        }
        if (!upToMessageId) {
            // When up to message ID is not specified, find the latest message that is retrieved
            var latestSentAt_2 = Timestamp.EPOCH;
            this._messages.forEach(function (message) {
                if (!message.pending && message.initialized && latestSentAt_2.isBefore(message.sentAt)) {
                    latestSentAt_2 = message.sentAt;
                    upToMessageId = message.messageId;
                }
            });
        }
        if (upToMessageId) {
            this._messageIdsToBeMarkedAsRead.push(upToMessageId);
            if (!this._markConversationAsReadTimeout) {
                this._markConversationAsReadTimeout = setTimeout(function () {
                    _this._markConversationAsReadTimeout = undefined;
                    _this.doMarkConversationRead(_this._messageIdsToBeMarkedAsRead);
                    _this._messageIdsToBeMarkedAsRead = [];
                }, 1000);
            }
        }
    };
    FirebaseConversation.prototype.markConversationDelivered = function (upToMessageId) {
        var _this = this;
        if (!this.isParticipant) {
            return;
        }
        var deliveryTimestamp = this._deliveryTimestamps.find(function (deliveryTimestamp) { return deliveryTimestamp.id === _this._me.userId; });
        if (deliveryTimestamp) {
            var deliveredUntil = fromFirebaseTimestamp(deliveryTimestamp.get('timestamp'));
            var upToMessage = this.getMessage(upToMessageId);
            if (!upToMessage.pending &&
                upToMessage.initialized &&
                (!deliveredUntil || deliveredUntil.isBefore(upToMessage.sentAt))) {
                // Need to update the deliveredUntil
                deliveryTimestamp.ref
                    .update('timestamp', toFirebaseTimestamp(upToMessage.sentAt))
                    .catch(function (err) {
                    if (err.code === 'permission-denied') {
                        // If the timestamp regresses, it would be rejected as permission denied
                        return;
                    }
                    throw err;
                });
            }
        }
    };
    FirebaseConversation.prototype.handleTypingUntilChange = function (change) {
        switch (change.type) {
            case 'added':
            case 'modified': {
                this.handleTypingInternal(change.doc);
                break;
            }
            case 'removed': {
                // For removed typing until, stop typing if it is in typing
                if (this._typingTimeouts.has(change.doc.id)) {
                    clearTimeout(this._typingTimeouts.get(change.doc.id));
                    this._typingTimeouts.delete(change.doc.id);
                    this.fireTyping(change.doc.id, false);
                }
                break;
            }
        }
    };
    FirebaseConversation.prototype.modifyTimestampArray = function (change, array) {
        var index = array.findIndex(function (value) { return value.id === change.doc.id; });
        switch (change.type) {
            case 'added':
            case 'modified': {
                if (index === -1) {
                    array.push(change.doc);
                }
                else {
                    array[index] = change.doc;
                }
                break;
            }
            case 'removed': {
                if (index !== -1) {
                    array.splice(index, 1);
                }
                break;
            }
        }
        return array;
    };
    FirebaseConversation.prototype.handleDeliveredUntilChange = function (change) {
        this._deliveryTimestamps = this.modifyTimestampArray(change, this._deliveryTimestamps);
        this._messages.forEach(function (message) { return message.initialized && message.handleDeliveredUntilChange(change); });
    };
    FirebaseConversation.prototype.handleReadUntilChange = function (change) {
        this._readTimestamps = this.modifyTimestampArray(change, this._readTimestamps);
        this._messages.forEach(function (message) { return message.initialized && message.handleReadUntilChange(change); });
    };
    FirebaseConversation.prototype.startTyping = function (expiration) {
        if (!this.isParticipant) {
            return;
        }
        expiration = expiration || 5000;
        var typingUntil = typeof expiration === 'number' ? Timestamp.fromMillis(Date.now() + expiration) : expiration;
        this._store
            .collection('conversations')
            .doc(this._conversationId)
            .collection('typingUntil')
            .doc(this._me.userId)
            .set({
            timestamp: toFirebaseTimestamp(typingUntil),
            userId: this._me.userId,
            conversationId: this._conversationId
        });
    };
    Object.defineProperty(FirebaseConversation.prototype, "myDeliveryTimestamp", {
        get: function () {
            var _this = this;
            var deliveryTimestamp = this._deliveryTimestamps.find(function (deliveryTimestamp) { return deliveryTimestamp.id === _this._me.userId; });
            return deliveryTimestamp && fromFirebaseTimestamp(deliveryTimestamp.get('timestamp'));
        },
        enumerable: true,
        configurable: true
    });
    FirebaseConversation.prototype.close = function () {
        _super.prototype.close.call(this);
        if (this._markConversationAsReadTimeout) {
            clearTimeout(this._markConversationAsReadTimeout);
        }
        if (this._messageIdsToBeMarkedAsRead.length > 0) {
            this.doMarkConversationRead(this._messageIdsToBeMarkedAsRead);
            this._messageIdsToBeMarkedAsRead = [];
        }
        // unsubscribe new messages
        if (this._unsubscribeNewMessages) {
            this._unsubscribeNewMessages();
            this._unsubscribeNewMessages = undefined;
        }
        this._deliveryTimestamps = [];
        this._readTimestamps = [];
        this._typingTimeouts.forEach(function (timeout) { return clearTimeout(timeout); });
        this._typingTimeouts.clear();
        this._eventEmitter.removeAllListeners();
        this._messages.forEach(function (message) { return message.close(); });
        this._messages.clear();
    };
    FirebaseConversation.prototype.stopTyping = function () {
        if (!this.isParticipant) {
            return;
        }
        this._store
            .collection('conversations')
            .doc(this._conversationId)
            .collection('typingUntil')
            .doc(this._me.userId)
            .delete();
    };
    FirebaseConversation.prototype.getMessageQuery = function (limit) {
        return new FirebaseMessageQuery(this._store, this, this._client, limit);
    };
    FirebaseConversation.prototype.getMessage = function (messageId) {
        var _this = this;
        if (this._messages.has(messageId)) {
            return this._messages.get(messageId);
        }
        else {
            // TODO: Why is this type annotation necessary?
            var message_1 = new FirebaseMessage(this._client, this, messageId);
            this._messages.set(messageId, message_1);
            this._store
                .collection('conversations')
                .doc(this._conversationId)
                .collection('messages')
                .doc(messageId)
                .get()
                .then(function (snapshot) { return message_1.init(snapshot, _this._deliveryTimestamps, _this._readTimestamps); });
            return message_1;
        }
    };
    FirebaseConversation.prototype.getMessageInternal = function (firebaseMessage) {
        if (this._messages.has(firebaseMessage.id)) {
            var message_2 = this._messages.get(firebaseMessage.id);
            if (message_2.initialized) {
                return Promise.resolve(message_2);
            }
            return new Promise(function (resolve) { return message_2.once('initialized', function () { return resolve(message_2); }); });
        }
        else {
            var message_3 = new FirebaseMessage(this._client, this, firebaseMessage.id);
            var promise = new Promise(function (resolve) {
                return message_3.once('initialized', function () { return resolve(message_3); });
            });
            message_3.init(firebaseMessage, this._deliveryTimestamps, this._readTimestamps);
            this._messages.set(firebaseMessage.id, message_3);
            return promise;
        }
    };
    FirebaseConversation.prototype.createDraftMessage = function () {
        if (!this.isParticipant) {
            throw new Error("Not a participant (me=" + this._me.userId + ")");
        }
        return new FirebaseMessage(this._client, this, new FirebaseMessageId().toString()).initDraft();
    };
    FirebaseConversation.prototype.sendMessage = function (draftMessage) {
        if (!this.isParticipant) {
            throw new Error("Not a participant (me=" + this._me.userId + ")");
        }
        if (!draftMessage.draft) {
            throw new Error('Message to be sent must be a draft message.');
        }
        if (draftMessage.conversation !== this) {
            throw new Error("Message to be sent must be a draft message for this conversation (" + this._conversationId + "), but is for (" + draftMessage.conversation.conversationId + ").");
        }
        draftMessage.finalizeDraft();
        var messageId = draftMessage.messageId;
        var messageRef = this._store
            .collection('conversations')
            .doc(this._conversationId)
            .collection('messages')
            .doc(messageId);
        this._messages.set(messageId, draftMessage);
        messageRef.set({
            conversationId: this._conversationId,
            messageId: messageId,
            sentAt: toFirebaseTimestamp(draftMessage.sentAt),
            sentBy: draftMessage.sentBy.userId,
            realSenderId: this._client.realMyself.userId,
            parts: draftMessage.parts.map(function (part) { return part.toFirestoreData(); }),
            metadata: draftMessage.metadata
        });
        return draftMessage;
    };
    FirebaseConversation.prototype.handleTypingInternal = function (typingTimestamp) {
        var userId = typingTimestamp.get('userId');
        var timeout = (fromFirebaseTimestamp(typingTimestamp.get('timestamp')) || Timestamp.EPOCH).toMillis();
        this.handleTyping(userId, timeout);
    };
    return FirebaseConversation;
}(Conversation));

var LocalMessage = /** @class */ (function (_super) {
    __extends(LocalMessage, _super);
    function LocalMessage(client, store, conversation, messageId, sentBy) {
        var _this = _super.call(this, conversation, messageId, sentBy || client.myself) || this;
        _this._client = client;
        _this._store = store;
        _this.initDraft = _this.initDraft.bind(_this);
        _this.finalizeDraft = _this.finalizeDraft.bind(_this);
        _this.addDraftPart = _this.addDraftPart.bind(_this);
        return _this;
    }
    Object.defineProperty(LocalMessage.prototype, "read", {
        get: function () {
            var lastReadMessageId = this.conversation.lastReadMessageId;
            if (!lastReadMessageId) {
                return false;
            }
            var lastReadMessage = this.conversation.getMessage(lastReadMessageId);
            return lastReadMessage.sentAt.toMillis() >= this.sentAt.toMillis();
        },
        enumerable: true,
        configurable: true
    });
    LocalMessage.prototype.getStore = function () {
        return this._store.namespace('messages');
    };
    LocalMessage.prototype.init = function () {
        var _this = this;
        var serialized = this.getStore().get(this.messageId);
        this._sentAt = Timestamp.fromDate(new Date(serialized.sentAt));
        this._metadata = serialized.metadata;
        this._channels = serialized.channels;
        this._skipChannels = serialized.skipChannels;
        this._sentVia = serialized.sentVia;
        this._parts = serialized.parts.map(function (part) { return new LocalMessagePart(part.type, part.body, _this); });
        this._pending = false;
        this._client.getUsers([serialized.sentBy]).then(function (_a) {
            var sentBy = _a[0];
            _this._sentBy = sentBy;
            _this._receipts = {};
            _this._receipts[serialized.sentBy] = exports.MessageReceiptType.READ;
            _this._initialized = true;
            _this._eventEmitter.emit('initialized', {
                event: 'initialized',
                message: _this
            });
        });
    };
    LocalMessage.prototype.saveToStore = function () {
        var serialized = {
            sentBy: this.sentBy.userId,
            sentAt: this.sentAt.toDate().toString(),
            metadata: this.metadata,
            channels: this.channels,
            skipChannels: this.skipChannels,
            sentVia: this.sentVia,
            parts: this.parts.map(function (part) {
                return {
                    type: part.type,
                    body: part.body
                };
            })
        };
        this.getStore().set(this.messageId, serialized);
    };
    LocalMessage.prototype.addDraftPart = function (type, body) {
        if (!this.draft) {
            throw new Error('Message is not a draft, unable to create draft parts');
        }
        var part = new LocalMessagePart(type, body, this);
        this.parts.push(part);
        return part;
    };
    LocalMessage.prototype.finalizeDraft = function () {
        _super.prototype.finalizeDraft.call(this);
        this._sentAt = Timestamp.serverTimestamp();
    };
    return LocalMessage;
}(Message));
var LocalMessageId = /** @class */ (function (_super) {
    __extends(LocalMessageId, _super);
    function LocalMessageId(seed) {
        return _super.call(this, 'local-message', seed) || this;
    }
    LocalMessageId.isLocalMessageId = function (encodedId) {
        return Id.isOfType('local-message', encodedId);
    };
    return LocalMessageId;
}(Id));
var LocalMessagePart = /** @class */ (function () {
    function LocalMessagePart(type, body, message) {
        this.type = type;
        this.body = body;
        this.message = message;
    }
    return LocalMessagePart;
}());

var LocalMessageQuery = /** @class */ (function (_super) {
    __extends(LocalMessageQuery, _super);
    function LocalMessageQuery(conversation) {
        var _this = _super.call(this) || this;
        _this._conversation = conversation;
        _this._initialized = conversation.initialized;
        _this._hasMore = false;
        _this._knownMessages = _this._conversation.getMessages();
        if (_this._initialized) {
            _this._eventEmitter.emit('initialized', {
                event: 'initialized',
                query: _this
            });
        }
        else {
            _this._conversation.on('initialized', function () {
                _this._initialized = true;
                _this._eventEmitter.emit('initialized', {
                    event: 'initialized',
                    query: _this
                });
            });
        }
        _this._conversation.on('changed', function () {
            var messages = _this._conversation.getMessages();
            var newMessages = xorBy(messages, _this._knownMessages, function (message) { return message.messageId; });
            if (newMessages.length > 0) {
                _this._eventEmitter.emit('updated', {
                    event: 'updated',
                    query: _this
                });
            }
            _this.updateMessageQuery();
        });
        return _this;
    }
    Object.defineProperty(LocalMessageQuery.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalMessageQuery.prototype, "hasMore", {
        get: function () {
            return this._hasMore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalMessageQuery.prototype, "messages", {
        get: function () {
            return this._conversation.getMessages();
        },
        enumerable: true,
        configurable: true
    });
    LocalMessageQuery.prototype.updateMessageQuery = function () {
        this._knownMessages = this._conversation.getMessages();
    };
    LocalMessageQuery.prototype.more = function (_limit) {
        var _this = this;
        return new Promise(function (resolve) { return resolve(_this); });
    };
    LocalMessageQuery.prototype.messagesAfter = function (_messages, _limit) {
        var _this = this;
        return new Promise(function (resolve) { return resolve(_this); });
    };
    return LocalMessageQuery;
}(MessageQuery));

var LocalConversation = /** @class */ (function (_super) {
    __extends(LocalConversation, _super);
    function LocalConversation(store, client, conversationId) {
        var _this = _super.call(this, client, conversationId) || this;
        _this._store = store;
        _this._messages = new Map();
        _this._initialized = false;
        _this._participants = [client.myself];
        _this._participantIds = new Set([client.myself.userId]);
        _this._readOnly = false;
        _this.getMessage = _this.getMessage.bind(_this);
        _this.sendMessage = _this.sendMessage.bind(_this);
        _this.startTyping = _this.startTyping.bind(_this);
        _this.stopTyping = _this.stopTyping.bind(_this);
        _this.markConversationRead = _this.markConversationRead.bind(_this);
        _this.markConversationDelivered = _this.markConversationDelivered.bind(_this);
        _this.createDraftMessage = _this.createDraftMessage.bind(_this);
        // Schedule/send any sequenced messages once the conversation is initialized
        _this.once('initialized', function () {
            _this.executeMessageSequence();
        });
        return _this;
    }
    Object.defineProperty(LocalConversation.prototype, "lastReadMessageId", {
        get: function () {
            return this._lastReadMessageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalConversation.prototype, "unreadCount", {
        get: function () {
            var lastReadMessage = this._lastReadMessageId && this.getMessage(this._lastReadMessageId);
            var unreadMessages = this.getMessages().filter(function (message) {
                if (!lastReadMessage) {
                    return true;
                }
                return message.sentAt.toMillis() > lastReadMessage.sentAt.toMillis();
            });
            return unreadMessages.length;
        },
        enumerable: true,
        configurable: true
    });
    LocalConversation.prototype.init = function () {
        var _this = this;
        if (this._initialized) {
            return;
        }
        if (this.getStore().has(this.conversationId)) {
            var serialized = this.getStore().get(this.conversationId);
            this.hydrate(serialized).then(function () {
                _this._initialized = true;
                _this._eventEmitter.emit('initialized', {
                    event: 'initialized',
                    conversation: _this
                });
            });
        }
        else {
            this.saveToStore();
            this._initialized = true;
            setTimeout(function () {
                _this._eventEmitter.emit('initialized', {
                    event: 'initialized',
                    conversation: _this
                });
            });
        }
    };
    LocalConversation.prototype.hydrate = function (serialized) {
        var _this = this;
        return new Promise(function (resolve) {
            _this._client.getUsers(serialized.participants).then(function (participants) {
                _this._readOnly = serialized.readOnly;
                _this._updatedAt = Timestamp.fromDate(new Date(serialized.updatedAt)) || Timestamp.now();
                _this._metadata = serialized.metadata;
                if (participants) {
                    _this._participants = participants;
                    participants.forEach(function (participant) {
                        _this._participantIds.add(participant.userId);
                    });
                }
                if (serialized.sequence) {
                    _this._sequence = serialized.sequence;
                }
                // This is brittle: the order of hydration matters. Messages must be hydrated last because
                //   they write back to the store.
                serialized.messages.forEach(function (messageId) {
                    _this._messages.set(messageId, _this.getMessage(messageId));
                });
                if (serialized.lastMessage) {
                    _this._lastMessage = _this.getLastMessage();
                }
                if (serialized.lastReadMessageId) {
                    _this._lastReadMessageId = serialized.lastReadMessageId;
                }
                resolve(_this);
            });
        });
    };
    LocalConversation.prototype.serialize = function () {
        var lastMessage = this.getLastMessage();
        return {
            createdAt: this.createdAt.toDate().toString(),
            updatedAt: this.updatedAt.toDate().toString(),
            messages: Array.from(this._messages.keys()),
            lastMessage: lastMessage && lastMessage.messageId,
            lastReadMessageId: this._lastReadMessageId,
            participants: this._participants.map(function (participant) { return participant.userId; }),
            metadata: this.metadata,
            readOnly: this.readOnly,
            unreadCount: this.unreadCount,
            sequence: this._sequence
        };
    };
    LocalConversation.prototype.saveToStore = function () {
        var serialized = this.serialize();
        this.getStore().set(this.conversationId, serialized);
        this._eventEmitter.emit('changed', {
            event: 'changed',
            conversation: this
        });
    };
    LocalConversation.prototype.getMessageQuery = function (_limit) {
        return new LocalMessageQuery(this);
    };
    LocalConversation.prototype.getMessage = function (messageId) {
        if (this._messages.has(messageId)) {
            return this._messages.get(messageId);
        }
        else {
            var message = new LocalMessage(this._client, this._store, this, messageId);
            message.init();
            this._messages.set(messageId, message);
            this.saveToStore();
            return message;
        }
    };
    LocalConversation.prototype.getMessages = function () {
        return Array.from(this._messages.values()).sort(function (a, b) {
            return a.sentAt.toMillis() - b.sentAt.toMillis();
        });
    };
    LocalConversation.prototype.getStore = function () {
        return this._store.namespace('conversations');
    };
    LocalConversation.prototype.createDraftMessage = function (sentBy, messageId) {
        return new LocalMessage(this._client, this._store, this, (messageId || new LocalMessageId()).toString(), sentBy).initDraft();
    };
    LocalConversation.prototype.sendMessage = function (draftMessage) {
        draftMessage.finalizeDraft();
        draftMessage.saveToStore();
        this._messages.set(draftMessage.messageId, draftMessage);
        this._lastMessage = this.getLastMessage();
        this.fireTyping(draftMessage.sentBy.userId, false);
        this.saveToStore();
        if (!draftMessage.sentBy.isMyself) {
            this._eventEmitter.emit('newMessage', {
                event: 'newMessage',
                conversation: this,
                message: draftMessage
            });
        }
        return draftMessage;
    };
    LocalConversation.prototype.getLastMessage = function () {
        return maxBy(this.getMessages(), function (message) {
            return message.sentAt.toMillis();
        });
    };
    LocalConversation.prototype.startTyping = function () { };
    LocalConversation.prototype.stopTyping = function () { };
    LocalConversation.prototype.markConversationRead = function (upToMessageId) {
        var previousLastReadMessage = this._lastReadMessageId && this.getMessage(this._lastReadMessageId);
        var newLastReadMessage = this.getMessage(upToMessageId);
        if (previousLastReadMessage &&
            previousLastReadMessage.sentAt.toMillis() >= newLastReadMessage.sentAt.toMillis()) {
            return;
        }
        this._lastReadMessageId = upToMessageId;
        this.saveToStore();
    };
    LocalConversation.prototype.markConversationDelivered = function () { };
    LocalConversation.prototype.startMessageSequence = function (sequence) {
        var _this = this;
        if (!this._initialized) {
            this.once('initialized', function () {
                _this.startMessageSequence(sequence);
            });
            return;
        }
        if (this._sequence) {
            return;
        }
        this._sequence = sequence;
        // Update the participants to include any new senders
        sequence.messages.forEach(function (message) {
            _this._participantIds.add(message.sendBy);
        });
        // And refresh the full UserModel for the participants
        this._client.getUsers(Array.from(this._participantIds)).then(function (newParticipants) {
            _this._participants = newParticipants;
        });
        this.saveToStore();
        this.executeMessageSequence();
    };
    LocalConversation.prototype.executeMessageSequence = function () {
        var _this = this;
        if (!this._sequence) {
            return;
        }
        // Send any messages that were scheduled to be send in the past, but are missing from localStorage
        var unsentMessages = this._sequence.messages.filter(function (message) {
            var messageId = new LocalMessageId(message.id).toString();
            return !_this._messages.has(messageId);
        });
        var senderIds = uniq(unsentMessages.map(function (message) { return message.sendBy; }));
        // Fetch all the users we need to send on behalf of:
        this._client.getUsers(senderIds).then(function (senders) {
            unsentMessages.forEach(function (message) {
                // This is guaranteed to find a sender since we have prefetched all of the senders
                var sender = senders.find(function (user) { return user.userId === message.sendBy; });
                var messageId = new LocalMessageId(message.id);
                var draftMessage = _this.createDraftMessage(sender, messageId);
                // Add message parts
                message.parts.forEach(function (messagePart) {
                    draftMessage.addDraftPart(messagePart.type, messagePart.body);
                });
                // If this message was intended to be sent in the past, send it immediately and backdate it.
                var msUntilTypeAt = message.typeAt && dateFns.differenceInMilliseconds(message.typeAt, new Date());
                var msUntilSendAt = dateFns.differenceInMilliseconds(message.sendAt, new Date());
                // Schedule typing indicator
                if (msUntilTypeAt && msUntilTypeAt > 0) {
                    setTimeout(function () {
                        _this.fireTyping(message.sendBy, true);
                    }, msUntilTypeAt);
                }
                // Schedule message delivery
                if (msUntilSendAt <= 0) {
                    // TODO: Implement back-dating the `sentAt` property of the message
                    _this.sendMessage(draftMessage);
                }
                else {
                    setTimeout(function () {
                        // Ensure this message still hasn't been sent
                        if (_this._messages.has(messageId.toString())) {
                            return;
                        }
                        _this.sendMessage(draftMessage);
                    }, msUntilSendAt);
                }
            });
        });
    };
    return LocalConversation;
}(Conversation));
var LocalConversationId = /** @class */ (function (_super) {
    __extends(LocalConversationId, _super);
    function LocalConversationId(seed) {
        return _super.call(this, 'local-conversation', seed) || this;
    }
    LocalConversationId.isLocalConversationId = function (encodedId) {
        return Id.isOfType('local-conversation', encodedId);
    };
    return LocalConversationId;
}(Id));

var Guest = /** @class */ (function (_super) {
    __extends(Guest, _super);
    function Guest(client, guestId) {
        if (guestId === void 0) { guestId = new GuestId(); }
        return _super.call(this, client, guestId.toString(), 'Guest', false, 'GUEST', undefined, undefined, undefined, true) || this;
    }
    return Guest;
}(User));
var GuestId = /** @class */ (function (_super) {
    __extends(GuestId, _super);
    function GuestId() {
        // There is only one guest user. We use a static seed to ensure
        //   the same GuestId is generated across page refreshes.
        return _super.call(this, 'guest', 'STATIC_GUEST_SEED_ID') || this;
    }
    GuestId.isGuestId = function (encodedId) {
        return Id.isOfType('guest', encodedId);
    };
    return GuestId;
}(Id));

var ChatClient = /** @class */ (function (_super) {
    __extends(ChatClient, _super);
    function ChatClient(app, fetchUserProfiles) {
        var _this = _super.call(this) || this;
        _this._auth = app.auth();
        _this._firestore = app.firestore();
        _this._firestore.settings({});
        _this._firebaseConversations = new Map();
        _this._localstore = store.namespace('chat');
        _this._localConversations = new Map();
        _this._users = new Map();
        _this._unsubscribes = [];
        _this._unreadMessageCount = 0;
        _this._unreadConversations = new Map();
        _this._fetchUserProfiles = fetchUserProfiles;
        _this._guest = new Guest(_this);
        _this.login = _this.login.bind(_this);
        _this.logout = _this.logout.bind(_this);
        _this.getConversation = _this.getConversation.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.getUsers = _this.getUsers.bind(_this);
        _this.assumeIdentity = _this.assumeIdentity.bind(_this);
        _this.handleConversationChange = _this.handleConversationChange.bind(_this);
        // @ts-ignore DEBUGGING HACK
        window.__CHAT_CLIENT__ = _this;
        return _this;
    }
    Object.defineProperty(ChatClient.prototype, "myself", {
        get: function () {
            return this._me || this._guest;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChatClient.prototype, "realMyself", {
        get: function () {
            return this._realMe;
        },
        enumerable: true,
        configurable: true
    });
    ChatClient.prototype.getUsers = function (userIds) {
        return this._getUsers(userIds);
    };
    ChatClient.prototype.recalculateUnreadMessageCount = function () {
        var _this = this;
        this._unreadMessageCount = 0;
        this._unreadConversations.forEach(function (unreadCount) { return (_this._unreadMessageCount += unreadCount); });
        this._eventEmitter.emit('unreadChanged', {
            event: 'unreadChanged',
            client: this
        });
    };
    ChatClient.prototype._getGuests = function (guestIds) {
        var _this = this;
        return guestIds.map(function (id) { return new Guest(_this, id); });
    };
    ChatClient.prototype._getUsers = function (userIds) {
        var _this = this;
        var existingUsers = userIds
            .map(function (userId) { return _this._users.get(userId); })
            .filter(function (user) { return !!user; })
            .map(function (user) { return user; });
        var fetchingUserIds = userIds.filter(function (userId) {
            return !_this._users.has(userId) && !GuestId.isGuestId(userId);
        });
        var fetchingGuestIds = userIds
            .filter(function (userId) { return GuestId.isGuestId(userId); })
            .map(function (encodedGuestId) { return GuestId.decode(encodedGuestId); });
        var guests = this._getGuests(fetchingGuestIds);
        // No need to fetch
        if (fetchingUserIds.length === 0) {
            return Promise.resolve(__spreadArrays(existingUsers, guests));
        }
        return Promise.all([this._fetchUserProfiles(fetchingUserIds), guests]).then(function (_a) {
            var fetchedUserProfiles = _a[0], fetchedGuestProfiles = _a[1];
            var fetchedUsers = fetchedUserProfiles.map(function (fetchedUserProfile) {
                var user = new User(_this, fetchedUserProfile.userId, fetchedUserProfile.displayName, fetchedUserProfile.internalMessagingUser, fetchedUserProfile.type, fetchedUserProfile.avatarUrl, fetchedUserProfile.expertRating, fetchedUserProfile.vanityId);
                _this._users.set(user.userId, user);
                return user;
            });
            return fetchedUsers.concat(fetchedGuestProfiles).concat(existingUsers);
        });
    };
    ChatClient.prototype.login = function (token) {
        var _this = this;
        if (this._auth.currentUser) {
            // If the user is already authenticated, logout first
            return this.logout().then(function () { return _this.login(token); });
        }
        return this._auth.setPersistence(firebase.auth.Auth.Persistence.NONE).then(function () {
            return _this._auth.signInWithCustomToken(token).then(function (credential) {
                if (credential.user) {
                    var uid_1 = credential.user.uid;
                    return _this._getUsers([uid_1]).then(function (_a) {
                        var me = _a[0];
                        _this._me = me;
                        _this._realMe = me;
                        // Subscribe for unread count and new messages (sent by the current user as well as received by the current user)
                        _this._unsubscribes.push(_this._firestore
                            .collection('conversations')
                            .where("participants." + uid_1 + ".unreadCount", '>', 0)
                            .onSnapshot(function (snapshots) {
                            snapshots.docChanges().forEach(function (change) {
                                if (!_this._firebaseConversations.has(change.doc.id)) {
                                    // only updates if the conversation is not cached (thus not calculate unread message count locally)
                                    switch (change.type) {
                                        case 'added':
                                        case 'modified':
                                            _this._unreadConversations.set(change.doc.id, change.doc.get("participants." + uid_1 + ".unreadCount"));
                                            break;
                                        case 'removed':
                                            _this._unreadConversations.delete(change.doc.id);
                                            break;
                                    }
                                }
                            });
                            _this.recalculateUnreadMessageCount();
                        }, function (error) {
                            return console.error("Global Per-Conversation Unread Count Subscription Error (me=" + (_this._me &&
                                _this._me.userId) + "): ", error);
                        }), _this._firestore
                            .collection('messages')
                            .where('sentBy', '==', uid_1)
                            .where('sentAt', '>', firebase.firestore.Timestamp.now())
                            .orderBy('sentAt', 'desc')
                            .onSnapshot(function (snapshot) {
                            snapshot
                                .docChanges()
                                .filter(function (change) { return change.type === 'added'; })
                                .forEach(function (change) {
                                return _this.fireNewMessage(change.doc.get('conversationId'), change.doc.id);
                            });
                        }, function (error) {
                            return console.error("Global New Sent Message Subscription Error (me=" + (_this._me &&
                                _this._me.userId) + "): ", error);
                        }), _this._firestore
                            .collection('messages')
                            .where("recipients." + uid_1, '>', firebase.firestore.Timestamp.now())
                            .onSnapshot(function (snapshot) {
                            snapshot
                                .docChanges()
                                .filter(function (change) { return change.type === 'added'; })
                                .forEach(function (change) {
                                return _this.fireNewMessage(change.doc.get('conversationId'), change.doc.id);
                            });
                        }, function (error) {
                            return console.error("Global New Received Message Subscription Error (me=" + (_this._me &&
                                _this._me.userId) + "): ", error);
                        }));
                        _this._eventEmitter.emit('authenticated', {
                            event: 'authenticated',
                            client: _this
                        });
                        return uid_1;
                    });
                }
                _this._me = undefined;
                throw new Error('User ID not available.');
            });
        });
    };
    ChatClient.prototype.assumeIdentity = function (userId) {
        var _this = this;
        if (!this._auth.currentUser || !this._realMe) {
            return Promise.reject('Not logged in');
        }
        if (!userId || userId === this._realMe.userId) {
            this._me = this._realMe;
            return Promise.resolve();
        }
        return this._auth.currentUser.getIdTokenResult().then(function (token) {
            if (!token.claims.allowedIdentities[userId]) {
                throw "Assuming identity for " + userId + " is not allowed.";
            }
            return _this._getUsers([userId]).then(function (assumedUser) {
                _this._me = assumedUser[0];
                return;
            });
        });
    };
    ChatClient.prototype.fireNewMessage = function (conversationId, messageId) {
        var _this = this;
        var conversation = this.getConversation(conversationId);
        var getNewMessage = function () {
            var message = conversation.getMessage(messageId);
            var fireEvent = function () {
                _this._eventEmitter.emit('newMessage', {
                    event: 'newMessage',
                    client: _this,
                    message: message
                });
            };
            if (message.initialized) {
                fireEvent();
            }
            else {
                message.once('initialized', fireEvent);
            }
        };
        if (conversation.initialized) {
            getNewMessage();
        }
        else {
            conversation.once('initialized', getNewMessage);
        }
    };
    Object.defineProperty(ChatClient.prototype, "unreadMessageCount", {
        get: function () {
            return this._unreadMessageCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChatClient.prototype, "unreadConversationCount", {
        get: function () {
            return this._unreadConversations.size;
        },
        enumerable: true,
        configurable: true
    });
    ChatClient.prototype.tryInitializeConversation = function (conversation, initData) {
        if (initData.conversation &&
            initData.deliveredUntil &&
            initData.readUntil &&
            initData.typingUntil) {
            conversation.init(initData.conversation, initData.typingUntil, initData.deliveredUntil, initData.readUntil);
            return true;
        }
        return false;
    };
    ChatClient.prototype.handleConversationChange = function (event) {
        if (event.conversation.unreadCount === 0) {
            this._unreadConversations.delete(event.conversation.conversationId);
        }
        else {
            this._unreadConversations.set(event.conversation.conversationId, event.conversation.unreadCount);
        }
        this.recalculateUnreadMessageCount();
    };
    /**
     * Get a local conversation by recipient ID(s), or create one with those participants if it doesn't exist.
     */
    ChatClient.prototype.getLocalConversationByRecipients = function (recipientIds) {
        var conversationId = new LocalConversationId(recipientIds.join(','));
        return this.getLocalConversationById(conversationId.toString());
    };
    /**
     * Get a local conversation by conversation ID, or create one with that ID if it doesn't exist.
     */
    ChatClient.prototype.getLocalConversationById = function (conversationId) {
        if (this._localConversations.has(conversationId)) {
            return this._localConversations.get(conversationId);
        }
        else {
            var conversation = new LocalConversation(this._localstore, this, conversationId);
            conversation.init();
            this._localConversations.set(conversationId, conversation);
            conversation.once('initialized', this.handleConversationChange);
            conversation.on('changed', this.handleConversationChange);
            return conversation;
        }
    };
    ChatClient.prototype.getConversation = function (conversationId) {
        var _this = this;
        if (LocalConversationId.isLocalConversationId(conversationId)) {
            return this.getLocalConversationById(conversationId);
        }
        if (!this._me) {
            throw new Error('Not authenticated');
        }
        if (this._firebaseConversations.has(conversationId)) {
            return this._firebaseConversations.get(conversationId);
        }
        else {
            var conversation_1 = new FirebaseConversation(this._firestore, this, conversationId);
            var initDataHolder_1 = { data: {} };
            this._firebaseConversations.set(conversationId, conversation_1);
            conversation_1.once('initialized', this.handleConversationChange);
            conversation_1.on('changed', this.handleConversationChange);
            this._unsubscribes.push(this._firestore
                .collection('conversations')
                .doc(conversationId)
                .onSnapshot(function (snapshot) {
                if (!conversation_1.initialized) {
                    initDataHolder_1.data.conversation = snapshot;
                    if (_this.tryInitializeConversation(conversation_1, initDataHolder_1.data)) {
                        initDataHolder_1.data = {};
                    }
                }
                else {
                    conversation_1.updateConversation(snapshot);
                }
            }, function (error) {
                return console.error("Conversation " + conversationId + " Update Subscription Error (me=" + (_this._me &&
                    _this._me.userId) + "): ", error);
            }), this._firestore
                .collection('conversations')
                .doc(conversationId)
                .collection('typingUntil')
                .onSnapshot(function (snapshot) {
                if (!conversation_1.initialized) {
                    initDataHolder_1.data.typingUntil = snapshot.docs;
                    if (_this.tryInitializeConversation(conversation_1, initDataHolder_1.data)) {
                        initDataHolder_1.data = {};
                    }
                }
                else {
                    snapshot
                        .docChanges()
                        .forEach(function (change) { return conversation_1.handleTypingUntilChange(change); });
                }
            }, function (error) {
                return console.error("Conversation " + conversationId + " Typing Indicator Subscription Error (me=" + (_this
                    ._me && _this._me.userId) + "): ", error);
            }), this._firestore
                .collection('conversations')
                .doc(conversationId)
                .collection('deliveredUntil')
                .onSnapshot(function (snapshot) {
                if (!conversation_1.initialized) {
                    initDataHolder_1.data.deliveredUntil = snapshot.docs;
                    if (_this.tryInitializeConversation(conversation_1, initDataHolder_1.data)) {
                        initDataHolder_1.data = {};
                    }
                }
                else {
                    snapshot
                        .docChanges()
                        .forEach(function (change) { return conversation_1.handleDeliveredUntilChange(change); });
                }
            }, function (error) {
                return console.error("Conversation " + conversationId + " Delivery Receipt Subscription Error (me=" + (_this
                    ._me && _this._me.userId) + "): ", error);
            }), this._firestore
                .collection('conversations')
                .doc(conversationId)
                .collection('readUntil')
                .onSnapshot(function (snapshot) {
                if (!conversation_1.initialized) {
                    initDataHolder_1.data.readUntil = snapshot.docs;
                    if (_this.tryInitializeConversation(conversation_1, initDataHolder_1.data)) {
                        initDataHolder_1.data = {};
                    }
                }
                else {
                    snapshot.docChanges().forEach(function (change) { return conversation_1.handleReadUntilChange(change); });
                }
            }, function (error) {
                return console.error("Conversation " + conversationId + " Read Receipt Subscription Error (me=" + (_this._me &&
                    _this._me.userId) + "): ", error);
            }));
            return conversation_1;
        }
    };
    ChatClient.prototype.logout = function () {
        var _this = this;
        if (this._auth.currentUser) {
            // Clean up the in-memory cached data
            this._firebaseConversations.forEach(function (conversation) { return conversation.close(); });
            this._firebaseConversations.clear();
            this._users.clear();
            this._unsubscribes.forEach(function (unsubscribe) { return unsubscribe(); });
            this._unsubscribes = [];
            return this._auth.signOut().then(function () {
                _this._me = undefined;
            });
        }
        else {
            return Promise.resolve();
        }
    };
    ChatClient.prototype.close = function () {
        _super.prototype.close.call(this);
        this.logout();
    };
    return ChatClient;
}(BaseModel));

// Firebase models
function createClient(options) {
    var loadFirebase;
    if (window.firebase) {
        loadFirebase = Promise.resolve();
    }
    else {
        window.firebase = firebase;
        loadFirebase = loadScriptAsync([
            "https://www.gstatic.com/firebasejs/" + firebase.SDK_VERSION + "/firebase-auth.js",
            "https://www.gstatic.com/firebasejs/" + firebase.SDK_VERSION + "/firebase-firestore.js",
        ]);
    }
    return loadFirebase.then(function () {
        if (firebase.apps.filter(function (app) { return app && app.name === options.projectId; }).length) {
            return new ChatClient(firebase.app(options.projectId), options.fetchUserProfiles);
        }
        else {
            return new ChatClient(firebase.initializeApp({
                apiKey: options.apiKey,
                authDomain: options.projectId + ".firebaseapp.com",
                projectId: options.projectId,
            }, options.projectId), options.fetchUserProfiles);
        }
    });
}

exports.ChatClient = ChatClient;
exports.ConversationModel = Conversation;
exports.FirebaseConversationModel = FirebaseConversation;
exports.FirebaseMessageId = FirebaseMessageId;
exports.FirebaseMessageModel = FirebaseMessage;
exports.FirebaseMessagePart = FirebaseMessagePart;
exports.FirebaseMessageQueryModel = FirebaseMessageQuery;
exports.LocalConversationId = LocalConversationId;
exports.LocalConversationModel = LocalConversation;
exports.LocalMessageId = LocalMessageId;
exports.LocalMessageModel = LocalMessage;
exports.LocalMessagePart = LocalMessagePart;
exports.LocalMessageQueryModel = LocalMessageQuery;
exports.MessageModel = Message;
exports.MessageQueryModel = MessageQuery;
exports.UserModel = User;
exports.createClient = createClient;
//# sourceMappingURL=browser.js.map
